export default __webpack_public_path__ + "static/media/img_cm_search.be034eaa.png";